export const GET_VENDOR_LOGIN_REQUEST = "GET_VENDOR_LOGIN_REQUEST";
export const GET_VENDOR_LOGIN_SUCCESS = "GET_VENDOR_LOGIN_SUCCESS";
